import { Armchair, Table2, Thermometer, Wifi } from "lucide-react";

import CenteredTitle from "shared/components/title/CenteredTitle";
import  { useState } from "react";
import { useTranslation } from 'react-i18next';

const AmenitiesSection = () => {
    const { t } = useTranslation();
    const [hovered, setHovered] = useState(null);

    return (
        <section className="py-10 md:py-20 px-6 w-full flex flex-col items-center">
            <CenteredTitle
                title={t('website.amenities.title')}
                subtitle={t('website.amenities.subtitle')}
            />
            {/* MOBILE — Horizontal scroll */}
            <div className="flex md:hidden  w-full max-w-6xl  gap-4  overflow-x-auto scrollbar-thin scrollbar-thumb-gray-300 py-8">
                {
                    amenities.map((amenity) => (
                        <div key={amenity.id} className="min-w-[250px]">
                            <Amenity
                                setHovered={setHovered}
                                hovered={hovered}
                                amenity={amenity}
                            />
                        </div>
                    ))
                }
            </div>

            {/* DESKTOP GRID */}
            <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-6 w-full max-w-6xl">
                {amenities.map((amenity) => (
                    <Amenity
                        key={amenity.id}
                        setHovered={setHovered}
                        hovered={hovered}
                        amenity={amenity}
                    />
                ))}
            </div>
        </section>
    );
};

export default AmenitiesSection;


const Amenity = ({ hovered, key, setHovered, amenity }) => {
    const { t } = useTranslation();
    const Icon = amenity.icon;
    const isActive = hovered === amenity.id;

    return (
        <div
            key={key || amenity.id}
            onMouseEnter={() => setHovered(amenity.id)} onMouseLeave={() => setHovered(null)}
            className={`
                relative border rounded-xl p-8 bg-white cursor-pointer
                transition-all duration-200
                ${isActive ? "border-lime-700 shadow-lg" : "border-gray-200"}
            `}
        >
            <Icon
                className={`w-10 h-10 mb-4 transition-colors duration-200 ${isActive ? "text-lime-700" : "text-gray-900"}`}
            />
            <h3 className={`font-semibold text-lg transition-colors duration-200 ${isActive ? "text-lime-700" : "text-gray-900"}`}>
                {t(`website.amenities.items.${amenity.key}.title`)}
            </h3>
            <p className={`mt-2 text-sm transition-colors duration-200 ${isActive ? "text-lime-700" : "text-gray-600"}`}>
                {t(`website.amenities.items.${amenity.key}.description`)}
            </p>
        </div>
    );
}

const amenities = [
    {
        id: 1,
        key: "wifi",
        title: "High-Speed WiFi",
        description: "Reliable ultra-fast internet for seamless productivity.",
        icon: Wifi,
    },
    {
        id: 2,
        key: "ac",
        title: "Air Conditioning",
        description: "Climate-controlled environment for comfort.",
        icon: Thermometer,
    },
    {
        id: 3,
        key: "desk",
        title: "Work Desk",
        description: "Spacious desks designed for focus and productivity.",
        icon: Table2,
    },
    {
        id: 4,
        key: "chairs",
        title: "Comfortable chairs",
        description: "Ergonomic seating, great for long working hours.",
        icon: Armchair,
    }
];
